import { createSelector, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { createAction } from "redux-smart-actions";
import { RootState } from "..";
import { LanguageDto } from "./types";

export interface LoadingState {
  language: LanguageDto;
  languages: LanguageDto[];
}

const initialState: LoadingState = {
  language: {
    Code: "tr-TR",
    EnumId: "71173a68-8b7c-4560-bbb6-d98d7817b5ac",
    Name: "Türkçe",
  },
  languages: [
    {
      Code: "tr-TR",
      EnumId: "71173a68-8b7c-4560-bbb6-d98d7817b5ac",
      Name: "Türkçe",
    },
  ],
};
const languageSlice = createSlice({
  name: "language",
  initialState: initialState,
  reducers: {
    setLanguage: (state, action: PayloadAction<LanguageDto>) => {
      state.language = action.payload;
    },
    setLanguages: (state, action: PayloadAction<LanguageDto[]>) => {
      state.languages = action.payload;
    },
  },
});

export default languageSlice.reducer;
export const { setLanguage, setLanguages } = languageSlice.actions;

const state = (state: RootState) => state;
export const languageSelector = createSelector(
  [state],
  (state) => state.language.language
);
export const languagesSelector = createSelector(
  [state],
  (state) => state.language.languages
);
